export default __webpack_public_path__ + "static/media/215068.2bbb3051.jpg";